// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { TbBrandAzure as RawTbBrandAzure } from "react-icons/tb";
export const TbBrandAzure = /* @__PURE__ */ createIcon(RawTbBrandAzure, "TbBrandAzure", 2);
